var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCollapseExpandHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3767_70092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3767_70092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V15H15V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3767_70092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.50024H0V3.75024H15V2.50024Z",
    fill: "#D21D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.625H5V6.875H15V5.625Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.8752H0V13.1253H15V11.8752Z",
    fill: "#D21D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75049H5V10.0005H15V8.75049Z",
    fill: "#D21D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00049V10.6255L2.60875 8.27736C2.67381 8.21876 2.72583 8.14713 2.76144 8.06714C2.79704 7.98714 2.81544 7.90055 2.81544 7.81299C2.81544 7.72542 2.79704 7.63884 2.76144 7.55884C2.72583 7.47884 2.67381 7.40722 2.60875 7.34861L0 5.00049Z",
    fill: "#CurrentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3767_70092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCollapseExpandHover);
export default __webpack_public_path__ + "static/media/Menu-Collapse-Expand-hover.297bf6b9d68cd1ac47800705867f4d47.svg";
export { ForwardRef as ReactComponent };